import React from 'react';
import { motion } from 'framer-motion';
import { solutionScenarios } from '../../data/solutions';
import { easeOutStrong, fadeUp } from '../../utils/motion';
export function SolutionsIntro() {
  return <>
      <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-24" data-id="element-1630" data-mp="1u48nitij7jez">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1631" data-mp="1z3l97axo2kfz">
          <div className="lg:col-span-6" data-id="element-1632" data-mp="1b6pdpno91wri">
            <p className="text-sm font-medium text-teal mb-5" data-id="element-1633" data-mp="1b80dzdihkmdv">Solutions</p>
            <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl text-ink-dark leading-[1.05] tracking-tight" data-id="element-1634" data-mp="1g4qws8lodw2z">
              Solutions for Knowledge, Human Capability, and Institutional
              Intelligence
            </h1>
          </div>
          <div className="lg:col-span-6 lg:pt-10" data-id="element-1635" data-mp="3ac6bhwdtqy9r">
            <p className="text-2xl text-ink-dark leading-relaxed mb-6" data-id="element-1636" data-mp="3aamx6bbqaxam">
              SyNeural builds systems that help researchers connect ideas,
              people develop sound judgment, and institutions make decisions
              they can explain and improve.
            </p>
            <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1637" data-mp="3f3xvtp6e07rg">
              Our{' '}
              <a href="/semantic-knowledge" className="text-navy font-semibold underline decoration-line underline-offset-4 hover:decoration-navy transition-colors duration-150" data-id="element-1638" data-mp="2rck5forsqm94">
                Semantic Knowledge Platform (SKP)
              </a>{' '}
              connects concepts, documents, research, and policies into usable
              knowledge. Our{' '}
              <a href="/human-capability" className="text-navy font-semibold underline decoration-line underline-offset-4 hover:decoration-navy transition-colors duration-150" data-id="element-1639" data-mp="glafd82ndxmr">
                Human Capability Framework
              </a>
              , including CJI and NCJI, defines assessment, development, and
              opportunity guidance based on approved definitions and research.{' '}
              <a href="/noetivra" className="text-navy font-semibold underline decoration-line underline-offset-4 hover:decoration-navy transition-colors duration-150" data-id="element-1640" data-mp="snk4rmtcku5q">
                Noetivra
              </a>{' '}
              brings these resources into interactive views and workflows
              configured for each setting. Organizations can use each component
              where it fits or bring them together around a specific problem.
            </p>
          </div>
        </motion.div>
      </section>

      <section className="bg-surface-bg py-16 lg:py-20 border-b border-line" data-id="element-1641" data-mp="eoaq4rksi83v">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1642" data-mp="3ddsqmli5xjxo">
          <motion.p {...fadeUp} className="font-heading font-bold text-2xl text-ink-dark mb-8" data-id="element-1643" data-mp="3dd9i1veek7wb">
            The approach changes with the setting.
          </motion.p>
          <motion.ul {...fadeUp} className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line rounded-lg overflow-hidden" data-id="element-1644" data-mp="3atmo8i9761j8">
            {solutionScenarios.map(scenario => <li key={scenario.setting} className="bg-white p-6 lg:p-8" data-id="element-1645" data-mp="30udwzx5pv10k">
                <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1646" data-mp="2vw409i4cfscu">
                  <span className="font-semibold text-ink-dark" data-id="element-1647" data-mp="2vvu5zic9mz1c">{scenario.setting}</span>{' '}
                  {scenario.need}
                </p>
              </li>)}
          </motion.ul>
          <motion.p {...fadeUp} className="mt-8 text-lg text-ink-muted leading-relaxed max-w-3xl" data-id="element-1648" data-mp="2n1pbmoxxb5h2">
            SyNeural is designed to support each of these uses without treating
            them as the same task.
          </motion.p>
        </div>
      </section>
    </>;
}